/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPageFragment = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 2H4v9.5h2V4h7v5h5v2.5h2V7.586l-.293-.293-5-5L14.414 2H14zm11.586 5H15V5.414zM20 13h-2v2h2zm-2 3.5h2v2h-2zM4 22v-2h2v2zm3.5-2h2v2h-2zm5.5 0h-2v2h2zm1.5 0h2v2h-2zm5.5 0h-2v2h2zM4 18.5v-2h2v2zM6 15v-2H4v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPageFragment as PageFragment };
